export default "__VITE_ASSET__rciJSFwg__"